import React, { useState } from "react";

import { useLoggedInUser } from "components/LoggedInUserProvider";
import DefaultWorkOrdersPage from "./DefaultWorkOrdersPage";
import MaintenanceWorkOrdersPage from "./MaintenanceWorkOrdersPage";

const WorkOrdersPage = () => {
  const { currentUser } = useLoggedInUser();
  const [isNewWorkOrderOpen, setIsNewWorkOrderOpen] = useState<boolean>(false);

  const handleCloseNewOrder = () => {
    setIsNewWorkOrderOpen(false);
  };

  const handleOpenNewOrder = () => {
    setIsNewWorkOrderOpen(true);
  };

  if (currentUser.isMaintenance) {
    return (
      <MaintenanceWorkOrdersPage
        isNewWorkOrderOpen={isNewWorkOrderOpen}
        onCloseNewOrderPopup={handleCloseNewOrder}
        onOpenNewOrderPopup={handleOpenNewOrder}
      />
    );
  }

  return (
    <DefaultWorkOrdersPage
      isNewWorkOrderOpen={isNewWorkOrderOpen}
      onCloseNewOrderPopup={handleCloseNewOrder}
      onOpenNewOrderPopup={handleOpenNewOrder}
    />
  );
};

export default WorkOrdersPage;
